var _defs, _style, _path, _use, _use2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarker3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 27",
    width: 20,
    height: 27,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Vector (1)-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 14,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAOAQMAAADOsQSRAAAAAXNSR0IB2cksfwAAAANQTFRFHzbHPBwf8QAAAAxJREFUeJxjYCAWAAAAKgABYuF0QwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 15,
    height: 15,
    id: "img2",
    href: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNSAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuMjczNTkgOC44NDI2NFY2LjYzMzA1TDUuOTU5MjcgOC44NDI2NEg1LjU5MTA1VjUuNTI4MzJINC4xMTgwMVY4Ljg0MjY0SDMuMzgxNDZWNS41MjgzMkgxLjkwODQzVjguODQyNjRIMS4xNzE4OFYxMy45OTg1SDEyLjU4ODFWNi42MzMxN0w5LjI3MzU5IDguODQyNjRaTTQuNDg1OTggMTIuNTI1MkgyLjY0NDYyVjEwLjY4MzhINC40ODU5OFYxMi41MjUyWk04LjE2ODc0IDEyLjUyNTJINi4zMjczOFYxMC42ODM4SDguMTY4NzRWMTIuNTI1MloiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik04Ljg4MDMgMi41ODAxNkM4Ljg4MDMgMy44MDIwNyA1LjA4NTc0IDQuNDkwODkgNC40NzQ2MyAzLjU4MzcyQzQuMjgyMzggMy45NDQzMSAzLjc3MjU3IDQuMDkyNzIgMy4zNzczNiAzLjkwNDI2QzIuNzIxOTkgMy41OTEzMiAzLjIxMDYgMy45ODc5NSAyLjUwMTk4IDMuOTg3OTVDMS45MDM1NiAzLjk4Nzk1IDEuNTk0OTIgMy4zMzE1MiAyLjAxODM4IDIuOTU3NjdDMi40OTgwOCAyLjUzNDM2IDIuNzgzNTUgMy4wMTAzNiAzLjMxNDQ5IDIuNjk3NDJDNC4wNzg3MiAyLjI0NzEyIDMuOTA3ODkgMi45NDkzOSA0LjY4MzUgMi4zNjI1OEM1LjE0MjA3IDIuMDE1NDUgNS41NjY2MyAyLjI5MjYyIDYuMDU4NDQgMi4wNjkxNkM2LjgzMTY0IDEuNzE3NjEgOC44ODAyOCAxLjEyNDE3IDguODgwMjggMi41ODAxN0w4Ljg4MDMgMi41ODAxNloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #1f36c7 } \r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m10 0.8c2.6 0 5.1 1 7 2.9 1.9 1.8 2.9 4.3 2.9 6.9 0 8.3-8.5 15.8-9.9 15.8-1.4 0-9.9-7.5-9.9-15.8 0-2.6 1-5.1 2.9-6.9 1.8-1.9 4.4-2.9 7-2.9zm-3 6.6c-0.8 0.8-1.3 1.8-1.3 3 0 1.1 0.5 2.2 1.3 3 0.8 0.8 1.9 1.3 3 1.3 1.1 0 2.2-0.5 3-1.3 0.8-0.8 1.3-1.9 1.3-3 0-1.2-0.5-2.2-1.3-3-0.8-0.9-1.9-1.3-3-1.3-1.1 0-2.2 0.5-3 1.3z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Layer 1",
    href: "#img1",
    x: 4,
    y: 5
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    id: "Frame 1000001676",
    href: "#img2",
    transform: "matrix(1,0,0,1,3,4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker3);
export default __webpack_public_path__ + "static/media/marker3.e4fc50974f075a627a798dfcc244e2f9.svg";
export { ForwardRef as ReactComponent };